
import { BlogSearch } from "@/components/blog/BlogSearch";
import { CategoriesFilter } from "@/components/blog/CategoriesFilter";

interface CategoryInfo {
  id: number;
  name: string;
  count?: number;
}

interface BlogFiltersSectionProps {
  searchInputValue: string;
  onSearchChange: (value: string) => void;
  categories: CategoryInfo[];
  selectedCategoryId: number | null;
  selectedCategoryName: string;
  onCategoryClick: (categoryId: number, categoryName: string) => void;
  onResetFilters: () => void;
  isSearching?: boolean;
}

export const BlogFiltersSection = ({
  searchInputValue,
  onSearchChange,
  categories,
  selectedCategoryId,
  onCategoryClick,
  onResetFilters,
  isSearching = false
}: BlogFiltersSectionProps) => {
  return (
    <div className="mb-8 space-y-4">
      <div className="w-full mb-2 flex items-center gap-2">
        <BlogSearch 
          searchTerm={searchInputValue}
          onSearchChange={onSearchChange}
          isSearching={isSearching}
        />
      </div>
      
      <div className="w-full">
        <CategoriesFilter 
          categories={categories}
          selectedCategoryId={selectedCategoryId}
          onCategoryClick={onCategoryClick}
          onResetFilters={onResetFilters}
        />
      </div>
    </div>
  );
};
